var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeriod(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 750,
    height: 500
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFF1F4"
    },
    d: "M536.968,95.026c-24.464-0.146-47.623,5.378-68.242,15.333c-8.261,3.989-17.912,4.133-26.165,0.128 C422.142,100.58,399.22,95.023,375,95.023s-47.142,5.557-67.561,15.464c-8.253,4.004-17.904,3.86-26.165-0.128 c-20.619-9.955-43.778-15.479-68.242-15.333c-83.195,0.497-151.675,67.427-153.97,150.591 c-2.417,87.593,67.869,159.36,154.916,159.36c24.217,0,47.135-5.556,67.552-15.46c8.165-3.961,17.752-3.961,25.917,0 c20.417,9.905,43.336,15.46,67.552,15.46c24.217,0,47.135-5.556,67.552-15.46c8.165-3.961,17.752-3.961,25.917,0 c20.417,9.905,43.336,15.46,67.552,15.46c87.048,0,157.334-71.767,154.916-159.36C688.643,162.452,620.163,95.523,536.968,95.026z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#A56F62",
      strokeWidth: 9,
      strokeMiterlimit: 10
    },
    d: "M522.063,123.16 c24.798,33.236,56.115,37.755,85.031,14.21"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC804D"
    },
    d: "M593.468,154.556l15.828-6.678c4.35-2.091,6.181-7.312,4.09-11.661h0 c-2.091-4.35-7.311-6.181-11.661-4.09l-15.828,6.677L593.468,154.556z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M530.805,132.445l0.963-1.479c2.697-4.142,1.864-9.465-1.861-11.891l0,0 c-3.724-2.425-8.93-1.034-11.627,3.107l-0.963,1.479c-2.697,4.141-1.864,9.465,1.861,11.89l0,0 C522.903,137.978,528.109,136.587,530.805,132.445z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M525.928,121.476L525.928,121.476c0.843-0.922,0.779-2.366-0.143-3.21l-10.905-8.188 c-0.922-0.843-2.366-0.779-3.21,0.143l0,0c-0.843,0.922-0.779,2.366,0.143,3.209l10.905,8.188 C523.64,122.462,525.085,122.398,525.928,121.476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M522.318,124.671L522.318,124.671c0.781-0.975,0.622-2.412-0.353-3.193l-11.418-7.456 c-0.975-0.781-2.412-0.622-3.194,0.353l0,0c-0.781,0.975-0.622,2.412,0.353,3.193l11.417,7.456 C520.1,125.805,521.537,125.647,522.318,124.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M520.305,128.587L520.305,128.587c0.719-1.022,0.471-2.446-0.551-3.165l-11.861-6.729 c-1.022-0.719-2.446-0.471-3.165,0.551l0,0c-0.719,1.022-0.471,2.446,0.552,3.165l11.86,6.729 C518.162,129.857,519.586,129.609,520.305,128.587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M522.312,134.671L522.312,134.671c0.673-1.053,0.362-2.465-0.69-3.138l-12.145-6.201 c-1.053-0.673-2.465-0.363-3.138,0.69l0,0c-0.673,1.053-0.363,2.465,0.69,3.138l12.145,6.201 C520.226,136.034,521.639,135.724,522.312,134.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M532.607,122.32l-4.583-11.312c0,0-4.991,2.86-3.111,7.031c1.88,4.171,3.672,8.189,3.672,8.189 L532.607,122.32z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C5C53"
    },
    d: "M524.676,117.4l0.484,4.105l0.075-0.403l0,0c-0.328,0.581-0.543,1.134-0.734,1.722 c-0.186,0.582-0.326,1.176-0.409,1.775c-0.18,1.196-0.137,2.41,0.091,3.568c-0.063-1.18,0.066-2.356,0.397-3.462 c0.159-0.554,0.369-1.091,0.617-1.604c0.244-0.506,0.544-1.021,0.858-1.428l0,0l0.12-0.284l-0.045-0.119L524.676,117.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C5C53"
    },
    d: "M523.751,121.535c-0.922,1.399-1.706,2.755-2.599,4.056c-0.442,0.654-0.938,1.257-1.446,1.864 c-0.514,0.606-1.095,1.14-1.7,1.722c0.792-0.25,1.55-0.659,2.206-1.189c0.657-0.528,1.249-1.145,1.737-1.829 c0.501-0.676,0.908-1.416,1.228-2.188C523.482,123.194,523.716,122.382,523.751,121.535z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#011838",
      strokeWidth: 14,
      strokeMiterlimit: 10
    },
    x1: 635.764,
    y1: 209.885,
    x2: 635.764,
    y2: 363.618
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59F01"
    },
    d: "M626.342,339.756l0.087,9.945c0,0-12.419,0.176-15.494,14.105l34.135-0.03l-0.545-24.18 L626.342,339.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19283B"
    },
    d: "M635.393,350.244c-0.041,2.158,1.281,3.933,2.952,3.965c1.672,0.032,3.06-1.691,3.102-3.849 c0.041-2.158-1.28-3.933-2.952-3.965C636.823,346.362,635.434,348.086,635.393,350.244z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#011838",
      strokeWidth: 14,
      strokeMiterlimit: 10
    },
    d: "M617.662,205.046 c-55.102,40.785-11.783,113.401-11.783,113.401"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59F01"
    },
    d: "M596.461,315.546l0.087,9.945c0,0-12.419,0.176-15.494,14.105l34.135-0.03l-0.545-24.18 L596.461,315.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19283B"
    },
    d: "M605.512,326.034c-0.041,2.158,1.28,3.933,2.952,3.965c1.672,0.032,3.06-1.691,3.102-3.849 c0.041-2.158-1.28-3.933-2.952-3.965C606.941,322.152,605.553,323.876,605.512,326.034z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#011838"
    },
    d: "M621.557,183.937h12.892c9.51,0,17.29,7.781,17.29,17.29v0c0,9.51-7.781,17.29-17.29,17.29 h-12.892c-9.51,0-17.29-7.781-17.29-17.29v0C604.266,191.717,612.047,183.937,621.557,183.937z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59F01"
    },
    d: "M604.872,192.99c0.213,1.883,1.479,3.493,3.273,4.103c3.972,1.35,9.664,2.668,16.495,2.339 c9.616-0.464,16.967-3.974,21.291-6.62c1.629-0.997,2.518-2.859,2.303-4.757c-1.94-17.113-3.71-32.796-5.638-49.807 c-1.113-9.825-9.982-16.89-19.807-15.775l-8.964,1.017c-9.175,1.041-15.769,9.322-14.728,18.496L604.872,192.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M630.089,122.983c1.084,3.672-3.012,8.119-9.15,9.931c-6.138,1.813-11.993,0.306-13.078-3.366 c-1.085-3.672,3.012-8.119,9.15-9.932C623.149,117.803,629.004,119.31,630.089,122.983z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M612.443,68.225l0.838-0.095c5.37-0.609,10.495,5.697,11.446,14.085l4.716,41.586l-20.285,2.301 l-4.716-41.585C603.491,76.128,607.073,68.834,612.443,68.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C5C53"
    },
    d: "M612.772,70.987l0.838-0.095c5.37-0.609,10.439,5.201,11.321,12.978l3.222,28.412 c0.635,5.601-3.391,10.658-8.992,11.293l0,0c-5.602,0.635-10.658-3.391-11.293-8.992l-3.222-28.412 C603.763,78.394,607.402,71.596,612.772,70.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M612.535,106.41c0.272,0.931,2.295,1.16,4.52,0.51c2.225-0.649,3.808-1.931,3.536-2.862 c-0.272-0.931-2.295-1.16-4.52-0.51C613.847,104.198,612.264,105.479,612.535,106.41z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C5C53"
    },
    d: "M637.366,95.453l-45.681,4.271c-1.998,0.187-3.77-1.282-3.957-3.28v0 c-0.187-1.999,1.282-3.77,3.28-3.957l45.681-4.271c1.998-0.187,3.77,1.282,3.957,3.28l0,0 C640.833,93.495,639.365,95.267,637.366,95.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA635F"
    },
    d: "M591.343,97.74c-0.832,0-1.545-0.651-1.623-1.482c-0.084-0.897,0.578-1.696,1.476-1.78 l45.681-4.271c0.052-0.005,0.104-0.007,0.155-0.007c0.847,0,1.545,0.637,1.624,1.482c0.041,0.435-0.09,0.859-0.369,1.196 c-0.278,0.336-0.671,0.544-1.105,0.584l-45.682,4.271C591.446,97.737,591.394,97.74,591.343,97.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#011838"
    },
    d: "M617.185,126.039L617.185,126.039c-11.156,1.043-21.045-7.155-22.088-18.311l-2.286-24.455 c-1-10.695,6.86-20.176,17.555-21.176l1.668-0.156c10.695-1,20.176,6.86,21.176,17.555l2.286,24.455 C636.54,115.107,628.341,124.996,617.185,126.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M622.858,99.24l-16.214,1.516c-4.696,0.439-8.858-3.012-9.297-7.708l-1.572-16.821l33.219-3.106 l1.573,16.821C631.005,94.639,627.554,98.801,622.858,99.24z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252538"
    },
    d: "M611.31,104.292c2.126,0.009,5.119-0.12,8.02-0.73c1.908-0.401,3.105,2.135,1.839,3.945 c-1.348,1.925-3.443,3.596-6.618,3.366c-2.602-0.188-4.131-1.128-5.023-2.248C608.266,107.042,609.415,104.284,611.31,104.292 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9292"
    },
    d: "M614.551,110.874c3.175,0.229,5.27-1.441,6.618-3.366c0.19-0.271,0.318-0.56,0.403-0.851 c-1.031-0.681-2.48-1.122-4.537-1.009c-3.176,0.174-5.027,2.097-6.102,4.178c-0.002,0.004-0.003,0.008-0.005,0.012 C611.812,110.371,612.984,110.761,614.551,110.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFABAB"
    },
    d: "M613.467,108.076c0.223,0.578,1.42,0.683,2.675,0.235c1.255-0.448,2.091-1.28,1.868-1.858 c-0.223-0.578-1.42-0.683-2.675-0.235C614.081,106.666,613.245,107.498,613.467,108.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M611.31,104.292c2.126,0.009,5.119-0.12,8.02-0.73c1.172-0.246,2.073,0.616,2.302,1.737 c-1.835,1.173-4.471,1.936-7.414,1.992c-1.887,0.036-3.659-0.223-5.184-0.704C609.219,105.382,610.116,104.287,611.31,104.292 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252538"
    },
    d: "M603.328,89.969c-1.306,0.122-2.265,1.279-2.143,2.585c0.122,1.306,1.279,2.265,2.585,2.143 c1.306-0.122,2.265-1.28,2.143-2.585C605.791,90.806,604.634,89.847,603.328,89.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252538"
    },
    d: "M621.24,88.294c-1.306,0.122-2.265,1.279-2.143,2.585c0.122,1.306,1.279,2.265,2.585,2.143 c1.306-0.122,2.265-1.279,2.143-2.585C623.703,89.132,622.546,88.172,621.24,88.294z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54321A"
    },
    d: "M624.847,83.58l-4.218-0.908c-0.924-0.199-1.835,0.389-2.034,1.314 c-0.199,0.925,0.389,1.835,1.314,2.034l4.218,0.908c0.924,0.199,1.835-0.389,2.034-1.314S625.772,83.779,624.847,83.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54321A"
    },
    d: "M603.01,84.319l-3.977,1.674c-0.872,0.367-1.281,1.371-0.914,2.243 c0.367,0.872,1.371,1.281,2.242,0.914l3.977-1.674c0.872-0.367,1.281-1.371,0.914-2.242 C604.885,84.362,603.881,83.952,603.01,84.319z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3C5B"
    },
    d: "M621.219,119.179c0.1,1.071-1.893,2.134-4.453,2.373c-2.559,0.239-4.715-0.435-4.815-1.507 c-0.1-1.071,1.893-2.134,4.453-2.373C618.963,117.433,621.119,118.108,621.219,119.179z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C4E48"
    },
    d: "M615.706,101.412l-5.052,0.472c-0.833,0.078-1.572-0.534-1.65-1.368l0,0 c-0.078-0.833,0.534-1.572,1.367-1.65l5.052-0.472c0.833-0.078,1.572,0.534,1.65,1.368l0,0 C617.152,100.596,616.539,101.334,615.706,101.412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C5C53"
    },
    d: "M613.238,102.174L613.238,102.174c-1.239,0.116-2.337-0.795-2.453-2.033l-0.8-8.556 c-0.116-1.239,0.795-2.337,2.033-2.453l0,0c1.239-0.116,2.337,0.794,2.453,2.033l0.8,8.556 C615.388,100.96,614.477,102.058,613.238,102.174z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3C5B"
    },
    d: "M626.074,66.187c-0.518-0.419-1.058-0.811-1.617-1.175c-2.947,1.718-7.482,3.061-12.654,3.545 c-5.165,0.483-9.866,0.006-13.08-1.134c-0.482,0.462-0.94,0.948-1.372,1.456c3.124,1.608,8.568,2.367,14.65,1.799 C618.09,70.109,623.304,68.35,626.074,66.187z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 571.961,
    y: 187.085,
    transform: "matrix(0.9784 -0.2066 0.2066 0.9784 -53.6621 125.3819)",
    style: {
      fill: "#0180AB"
    },
    width: 3,
    height: 265.048
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 615.856,
    y: 187.085,
    transform: "matrix(0.9784 -0.2066 0.2066 0.9784 -52.715 134.4514)",
    style: {
      fill: "#0180AB"
    },
    width: 3,
    height: 265.048
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 549.625,
    y: 205.235,
    style: {
      fill: "#0180AB"
    },
    width: 43.895,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 554.365,
    y: 227.544,
    style: {
      fill: "#0180AB"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 559.107,
    y: 249.852,
    style: {
      fill: "#0180AB"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 563.847,
    y: 272.16,
    style: {
      fill: "#0180AB"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 568.588,
    y: 294.468,
    style: {
      fill: "#0180AB"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 573.328,
    y: 316.777,
    style: {
      fill: "#0180AB"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 578.07,
    y: 339.085,
    style: {
      fill: "#0180AB"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 582.81,
    y: 361.393,
    style: {
      fill: "#0180AB"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 587.551,
    y: 383.701,
    style: {
      fill: "#0180AB"
    },
    width: 43.895,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 592.291,
    y: 406.01,
    style: {
      fill: "#0180AB"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 597.032,
    y: 428.318,
    style: {
      fill: "#0180AB"
    },
    width: 43.896,
    height: 3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 430.464,
    y: 318.109,
    transform: "matrix(0.2064 -0.9785 0.9785 0.2064 134.0822 804.5273)",
    style: {
      fill: "#3EBCE5"
    },
    width: 265.048,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 386.569,
    y: 318.109,
    transform: "matrix(0.2064 -0.9785 0.9785 0.2064 99.2417 761.5736)",
    style: {
      fill: "#3EBCE5"
    },
    width: 265.048,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 542.928,
    y: 205.235,
    style: {
      fill: "#3EBCE5"
    },
    width: 43.895,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 538.188,
    y: 227.544,
    style: {
      fill: "#3EBCE5"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 533.446,
    y: 249.852,
    style: {
      fill: "#3EBCE5"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 528.706,
    y: 272.16,
    style: {
      fill: "#3EBCE5"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 523.965,
    y: 294.468,
    style: {
      fill: "#3EBCE5"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 519.225,
    y: 316.777,
    style: {
      fill: "#3EBCE5"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 514.484,
    y: 339.085,
    style: {
      fill: "#3EBCE5"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.743,
    y: 361.393,
    style: {
      fill: "#3EBCE5"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 505.002,
    y: 383.701,
    style: {
      fill: "#3EBCE5"
    },
    width: 43.896,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 500.262,
    y: 406.01,
    style: {
      fill: "#3EBCE5"
    },
    width: 43.895,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 495.521,
    y: 428.318,
    style: {
      fill: "#3EBCE5"
    },
    width: 43.896,
    height: 3
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -69.8964 339.6122)",
    style: {
      fill: "#0180AB"
    },
    cx: 375,
    cy: 254.178,
    rx: 194.517,
    ry: 194.517
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0180AB"
    },
    d: "M426.025,407.403H323.974c-22.805,0-41.292,18.487-41.292,41.292v0h184.636v0 C467.318,425.89,448.831,407.403,426.025,407.403z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -69.8964 339.6122)",
    style: {
      fill: "#3EBCE5"
    },
    cx: 375,
    cy: 254.178,
    rx: 177.485,
    ry: 177.485
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -69.8964 339.6122)",
    style: {
      fill: "#DFF1F4"
    },
    cx: 375,
    cy: 254.178,
    rx: 171.253,
    ry: 171.253
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -69.8964 339.6122)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 375,
    cy: 254.178,
    rx: 164.22,
    ry: 164.22
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3E1E5"
    },
    d: "M516.999,171.652L375,254.178h162.031l2.187,0.157c0-0.053,0.002-0.105,0.002-0.157 C539.22,224.093,531.123,195.902,516.999,171.652z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 371.222,
    y: 94.99,
    style: {
      fill: "#0180AB"
    },
    width: 7.556,
    height: 18.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.222,
    y: 395.256,
    style: {
      fill: "#0180AB"
    },
    width: 7.556,
    height: 18.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.077,
    y: 250.401,
    style: {
      fill: "#0180AB"
    },
    width: 18.111,
    height: 7.556
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.812,
    y: 250.401,
    style: {
      fill: "#0180AB"
    },
    width: 18.111,
    height: 7.556
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.233,
    y: 320.203,
    transform: "matrix(0.5001 -0.866 0.866 0.5001 -32.6698 601.9245)",
    style: {
      fill: "#0180AB"
    },
    width: 7.556,
    height: 18.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.211,
    y: 170.043,
    transform: "matrix(0.5001 -0.866 0.866 0.5001 -32.6224 301.6859)",
    style: {
      fill: "#0180AB"
    },
    width: 7.556,
    height: 18.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.456,
    y: 374.461,
    transform: "matrix(0.8615 -0.5078 0.5078 0.8615 -132.2393 282.2457)",
    style: {
      fill: "#0180AB"
    },
    width: 7.556,
    height: 18.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.988,
    y: 115.785,
    transform: "matrix(0.8615 -0.5078 0.5078 0.8615 -22.0087 168.9986)",
    style: {
      fill: "#0180AB"
    },
    width: 7.556,
    height: 18.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.941,
    y: 380.455,
    transform: "matrix(0.4996 -0.8663 0.8663 0.4996 -182.7252 452.1517)",
    style: {
      fill: "#0180AB"
    },
    width: 18.111,
    height: 7.556
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.948,
    y: 120.346,
    transform: "matrix(0.4996 -0.8663 0.8663 0.4996 117.6644 451.9355)",
    style: {
      fill: "#0180AB"
    },
    width: 18.111,
    height: 7.556
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.018,
    y: 327.328,
    transform: "matrix(0.8587 -0.5124 0.5124 0.8587 -134.8996 172.857)",
    style: {
      fill: "#0180AB"
    },
    width: 18.111,
    height: 7.556
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.871,
    y: 173.473,
    transform: "matrix(0.8588 -0.5124 0.5124 0.8588 -19.6437 283.2416)",
    style: {
      fill: "#0180AB"
    },
    width: 18.111,
    height: 7.556
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBCE5"
    },
    d: "M375,124.863c-4.321,0-7.824,3.503-7.824,7.824v113.668c0,4.321,3.503,7.824,7.824,7.824 c4.321,0,7.824-3.503,7.824-7.824V132.687C382.824,128.366,379.321,124.863,375,124.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBCE5"
    },
    d: "M471.291,198.97c-1.099-1.94-3.562-2.621-5.502-1.522l-90.253,51.142 c-1.94,1.099-2.621,3.562-1.522,5.502c1.099,1.94,3.562,2.621,5.502,1.522l90.253-51.142 C471.709,203.373,472.39,200.91,471.291,198.97z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -0.012 0.012 0.9999 -3.0249 4.521)",
    style: {
      fill: "#0180AB"
    },
    cx: 375,
    cy: 254.178,
    rx: 18.469,
    ry: 18.469
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7479 -0.6638 0.6638 0.7479 -74.1869 313.0244)",
    style: {
      fill: "#3EBCE5"
    },
    cx: 375,
    cy: 254.179,
    rx: 10.693,
    ry: 10.693
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E71C2E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M478.711,159.706 c20.482,22.472,33.759,51.626,36.178,83.809"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E71C2E"
    },
    points: "506.408,237.991 515.626,250.704 522.027,236.365  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#25576B",
      strokeMiterlimit: 10
    },
    d: "M107.033,398.292c0,0-25.382-0.478-33.454-31.176"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59F01"
    },
    d: "M69.779,365.979c0.296,1.959,2.125,3.307,4.084,3.011s3.307-2.125,3.011-4.084 c-0.296-1.959-2.125-3.307-4.084-3.01C70.83,362.192,69.482,364.02,69.779,365.979z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#25576B",
      strokeMiterlimit: 10
    },
    d: "M107.842,399.02c0,0-22.484-11.786-15.965-42.851"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59F01"
    },
    d: "M88.987,353.451c-0.612,1.885,0.42,3.908,2.305,4.52c1.885,0.612,3.908-0.42,4.52-2.305 c0.612-1.885-0.42-3.908-2.305-4.52C91.622,350.534,89.598,351.566,88.987,353.451z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F7A2A"
    },
    d: "M85.223,448.695c-41.338-51.255,3.808-76.57,18.74-52.518c0,0-21.417-52.126,11.926-64.099 c30.719-11.031,65.59,47.925,65.59,116.617H85.223z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#25576B",
      strokeMiterlimit: 10
    },
    d: "M666.229,402.012c0,0,20.886-14.43,10.643-44.473"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59F01"
    },
    d: "M679.41,354.491c0.836,1.797,0.057,3.93-1.739,4.766c-1.797,0.836-3.931,0.057-4.767-1.739 c-0.836-1.796-0.057-3.93,1.739-4.766C676.44,351.916,678.574,352.695,679.41,354.491z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#25576B",
      strokeMiterlimit: 10
    },
    d: "M667.943,400.47c0,0,25.128-3.611,29.345-35.071"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59F01"
    },
    d: "M700.919,363.801c-0.052,1.981-1.7,3.544-3.681,3.492c-1.981-0.052-3.544-1.7-3.492-3.681 c0.052-1.981,1.7-3.544,3.681-3.492C699.408,360.173,700.971,361.821,700.919,363.801z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F7A2A"
    },
    d: "M707.227,391.836L707.227,391.836L707.227,391.836c-4.765,35.434-37.352,60.295-72.786,55.53v0 C639.207,411.933,671.794,387.071,707.227,391.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#709632"
    },
    d: "M668.197,362.934L668.197,362.934L668.197,362.934c14.412,32.719-0.428,70.926-33.147,85.338v0 C620.637,415.553,635.478,377.346,668.197,362.934z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DC11E"
    },
    d: "M503.679,436.966c2.473,0,4.775,0.707,6.739,1.911c4.284-11.049,14.816-18.977,27.264-19.447 c9.289-12.431,24.121-20.479,40.834-20.479c14.584,0,27.727,6.139,37.014,15.961c1.69-0.248,3.418-0.381,5.177-0.381 c13.228,0,24.751,7.268,30.816,18.023c1.328-0.315,2.711-0.487,4.135-0.487c9.845,0,17.826,7.981,17.826,17.826H490.752 C490.752,442.754,496.539,436.966,503.679,436.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DC11E"
    },
    d: "M111.448,436.966c2.473,0,4.775,0.707,6.739,1.911c4.284-11.049,14.816-18.977,27.264-19.447 c9.289-12.431,24.121-20.479,40.834-20.479c14.584,0,27.727,6.139,37.014,15.961c1.69-0.248,3.418-0.381,5.177-0.381 c13.228,0,24.751,7.268,30.816,18.023c1.327-0.315,2.711-0.487,4.134-0.487c9.845,0,17.826,7.981,17.826,17.826H98.521 C98.521,442.754,104.309,436.966,111.448,436.966z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 59.639,
    y: 448.695,
    style: {
      fill: "#3E5C70"
    },
    width: 630.722,
    height: 3.161
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFB692",
      strokeWidth: 9,
      strokeMiterlimit: 10
    },
    d: "M167.256,229.135 c5.471,55.576,77.685,42.65,77.685,42.65"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6711C"
    },
    d: "M178.268,240.998l-1.813-17.083c-0.743-4.769-5.211-8.032-9.979-7.289v0 c-4.769,0.743-8.032,5.21-7.289,9.979L161,243.688L178.268,240.998z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB692"
    },
    d: "M238.86,268.814c0.202-7.064,10.255-4.925,10.255-4.925l6.44-3.17c0,0,2.574,5.858-3.657,7.375 c0,0,8.37,3.452,9.739,7.132c0.643,1.728-2.129,8.327-5.081,10.787c-0.626,0.522-1.551,0.425-2.056-0.214 c-1.213-1.535-3.93-4.35-7.945-5.027C240.96,279.828,234.098,275.534,238.86,268.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M251.897,268.093c0,0-1.689,4.981-7.794,4.529c0,0,5.441-0.542,7.415-4.682L251.897,268.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M247.248,277.49c0,0,3.236-2.774,4.64-6.803C251.888,270.687,253.05,275.14,247.248,277.49z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M248.443,276.403l0.285-0.198c0,0,6.244,3.643,8.447,9.226c-0.084,0.087-0.169,0.17-0.254,0.251 C255.871,283.665,253.074,279.029,248.443,276.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M251.492,272.686l0.118-0.548c0,0,7.048,1.62,9.52,6.491c-0.445,1.281-1.109,2.715-1.894,4.029 c-0.854-1.539-3.682-5.93-9.022-7.829l0.186-0.389c0,0,7.096,1.606,9.129,7.447l1.396-2.724 C260.924,279.164,258.101,274.044,251.492,272.686z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#284159",
      strokeWidth: 13,
      strokeMiterlimit: 10
    },
    x1: 161.114,
    y1: 294.775,
    x2: 161.114,
    y2: 448.507
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B0D"
    },
    d: "M170.537,424.645l-0.087,9.945c0,0,12.419,0.176,15.494,14.105l-34.135-0.03l0.546-24.18 L170.537,424.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19283B"
    },
    d: "M161.486,435.133c0.041,2.158-1.28,3.933-2.952,3.965c-1.672,0.032-3.06-1.691-3.102-3.849 c-0.041-2.158,1.28-3.933,2.952-3.965C160.056,431.252,161.444,432.975,161.486,435.133z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#284159"
    },
    d: "M156.577,268.826h-12.892c-9.51,0-17.29,7.78-17.29,17.29v0c0,9.51,7.781,17.29,17.29,17.29 h12.892c9.51,0,17.29-7.781,17.29-17.29v0C173.867,276.606,166.087,268.826,156.577,268.826z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECB220"
    },
    d: "M172.06,276.425c0.01,1.895-1.057,3.643-2.767,4.461c-3.785,1.809-9.282,3.789-16.105,4.268 c-9.603,0.674-17.317-1.944-21.923-4.063c-1.735-0.798-2.838-2.542-2.848-4.452c-0.092-17.223-0.185-33.005-0.277-50.125 c-0.053-9.888,7.92-17.949,17.808-18.001l9.021-0.048c9.234-0.049,16.759,7.396,16.808,16.63L172.06,276.425z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB692"
    },
    d: "M138.761,209.882c-0.644,3.774,3.949,7.707,10.258,8.783c6.309,1.076,11.945-1.111,12.589-4.885 c0.644-3.774-3.949-7.707-10.258-8.783C145.041,203.919,139.405,206.107,138.761,209.882z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB692"
    },
    d: "M149.824,153.425l-0.843,0.005c-5.405,0.029-9.749,6.895-9.705,15.337l0.222,41.852l20.415-0.108 l-0.222-41.852C159.646,160.216,155.228,153.396,149.824,153.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M149.824,156.98l-0.843,0.005c-5.405,0.029-9.752,6.396-9.711,14.223l0.152,28.594 c0.03,5.637,4.624,10.183,10.261,10.153l0,0c5.637-0.03,10.183-4.624,10.153-10.261l-0.152-28.594 C159.643,163.273,155.228,156.952,149.824,156.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M154.237,191.354c-0.16,0.957-2.143,1.422-4.428,1.04c-2.286-0.382-4.009-1.468-3.849-2.425 c0.16-0.957,2.143-1.422,4.428-1.04C152.674,189.312,154.397,190.397,154.237,191.354z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#284159",
      strokeWidth: 13,
      strokeMiterlimit: 10
    },
    x1: 140.004,
    y1: 294.775,
    x2: 140.004,
    y2: 448.507
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECB220"
    },
    d: "M149.426,424.645l-0.087,9.945c0,0,12.419,0.176,15.494,14.105l-34.135-0.03l0.545-24.18 L149.426,424.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19283B"
    },
    d: "M140.375,435.133c0.041,2.158-1.281,3.933-2.952,3.965c-1.672,0.032-3.06-1.691-3.102-3.849 c-0.041-2.158,1.28-3.933,2.952-3.965C138.945,431.252,140.334,432.975,140.375,435.133z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#875330"
    },
    d: "M161.717,189.251h-23.038c-5.572,0-10.088-4.517-10.088-10.088v-8.792 c0-5.571,4.517-10.088,10.088-10.088h23.038c5.572,0,10.088,4.517,10.088,10.088v8.792 C171.805,184.735,167.288,189.251,161.717,189.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M172.064,179.699h-43.749c-1.914,0-3.466-1.552-3.466-3.466l0,0 c0-1.914,1.552-3.466,3.466-3.466h43.749c1.914,0,3.466,1.552,3.466,3.466l0,0 C175.529,178.147,173.978,179.699,172.064,179.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA635F"
    },
    d: "M128.314,177.699c-0.808,0-1.465-0.658-1.465-1.466c0-0.808,0.657-1.466,1.465-1.466h43.75 c0.808,0,1.465,0.658,1.465,1.466c0,0.808-0.657,1.466-1.465,1.466H128.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB692"
    },
    d: "M150.189,206.224L150.189,206.224c-10.684,0-19.345-8.661-19.345-19.345V164.18 c0-10.243,8.304-18.547,18.547-18.547h1.598c10.243,0,18.547,8.304,18.547,18.547v22.699 C169.534,197.563,160.873,206.224,150.189,206.224z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D88D87"
    },
    points: "130.844,168.698 169.534,166.526 169.534,165.239 130.844,165.239  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#252538"
    },
    cx: 141.612,
    cy: 173.863,
    r: 2.264
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#252538"
    },
    cx: 158.766,
    cy: 173.863,
    r: 2.264
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#875330"
    },
    d: "M162.551,167.438l-3.924-1.236c-0.86-0.271-1.777,0.207-2.048,1.067 c-0.271,0.86,0.207,1.777,1.067,2.048l3.924,1.236c0.86,0.271,1.777-0.207,2.048-1.067 C163.888,168.626,163.411,167.709,162.551,167.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#875330"
    },
    d: "M141.752,166.202l-3.924,1.236c-0.86,0.271-1.338,1.188-1.067,2.048 c0.271,0.86,1.188,1.338,2.048,1.067l3.924-1.236c0.86-0.271,1.338-1.188,1.067-2.048 C143.529,166.408,142.612,165.931,141.752,166.202z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M154.627,195.415c0,1.026-1.987,1.858-4.438,1.858s-4.438-0.832-4.438-1.858 c0-1.026,1.987-1.858,4.438-1.858S154.627,194.389,154.627,195.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M150.189,183.268L150.189,183.268c-1.78,0-3.222-1.443-3.222-3.222v-5.225 c0-1.78,1.443-3.222,3.222-3.222l0,0c1.779,0,3.222,1.442,3.222,3.222v5.225C153.411,181.825,151.969,183.268,150.189,183.268z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F79C97"
    },
    d: "M151.901,181.438L151.901,181.438c-0.47,0-0.851-0.381-0.851-0.851v-6.048 c0-0.47,0.381-0.851,0.851-0.851l0,0c0.47,0,0.851,0.381,0.851,0.851v6.048C152.752,181.057,152.371,181.438,151.901,181.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C5C53"
    },
    d: "M145.525,182.925l-0.456,0.359c0.234,0.28,3.413,3.92,9.974,3.371l-0.556-0.49l0.399-0.454 l1.58,1.39l-0.667,0.083c-0.75,0.093-1.46,0.135-2.131,0.135c-5.973,0-8.812-3.335-9.075-3.661l-0.677,0.533 C143.917,184.19,143.733,182.454,145.525,182.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0180AB"
    },
    d: "M156.996,143.514h-14.207c-7.817,0-14.155,6.337-14.155,14.155v8.258h13.103v-3.168 c0-2.999,2.431-5.43,5.43-5.43h5.45c2.999,0,5.43,2.431,5.43,5.43v3.168h13.103v-8.258 C171.151,149.852,164.814,143.514,156.996,143.514z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.308,
    y: 164.245,
    style: {
      fill: "#3EBCE5"
    },
    width: 53.843,
    height: 2.723
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 167.007,
    y: 273.003,
    transform: "matrix(0.9753 -0.221 0.221 0.9753 -57.0042 59.9938)",
    style: {
      fill: "#DC804D"
    },
    width: 145.099,
    height: 23.389
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B56239"
    },
    d: "M290.286,272.693L290.286,272.693c-0.817-3.606-4.403-5.867-8.008-5.05l-89.795,21.367 c-3.605,0.817-5.866,4.403-5.049,8.008c0.817,3.605,4.402,5.866,8.008,5.049l89.795-21.366 C288.842,279.884,291.103,276.298,290.286,272.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC804D"
    },
    d: "M327.447,282.718l-13.719-14.831l5.984-19.296l32.82-7.439 c-8.129-8.663-20.5-12.917-32.924-10.102c-18.65,4.227-30.343,22.773-26.116,41.423c4.227,18.65,22.773,30.343,41.423,26.116 c12.424-2.816,21.751-11.988,25.351-23.31L327.447,282.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC804D"
    },
    d: "M147.075,287.718l13.719,14.831l-5.984,19.297l-32.82,7.439 c8.129,8.663,20.5,12.918,32.924,10.102c18.65-4.227,30.343-22.773,26.116-41.423s-22.773-30.343-41.423-26.116 c-12.423,2.816-21.751,11.988-25.351,23.31L147.075,287.718z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFB692",
      strokeWidth: 9,
      strokeMiterlimit: 10
    },
    d: "M130.094,225.29 c-19.988,52.146,50.373,72.915,50.373,72.915"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6711C"
    },
    d: "M134.319,242.726l4.288-16.635c0.975-4.727-2.066-9.348-6.792-10.323h0 c-4.726-0.975-9.348,2.066-10.323,6.792l-4.288,16.635L134.319,242.726z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB692"
    },
    d: "M174.663,295.013c-0.067-7.176,10.215-5.392,10.215-5.392l6.412-3.465 c0,0,2.837,5.845-3.427,7.624c0,0,5.731,3.038,10.53,2.326c5.858-0.87-0.19,11.719-5.608,14.326 c-2.943,1.416-5.959-2.394-10.059-2.927C177.013,306.764,170.089,302.014,174.663,295.013z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M186.203,301.097l-0.246,0.469c0,0,5.759,3.982,11.605,4.357 c0.186-0.261,0.368-0.525,0.543-0.794C195.745,305.197,191.489,304.665,186.203,301.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M184.64,304.695c0,0,5.155,3.647,9.744,4.703c0.252-0.202,0.502-0.422,0.75-0.654 c-1.965-0.41-5.875-1.542-10.242-4.558L184.64,304.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M187.622,297.767c0,0,5.748,4.241,12.55,3.299c0.154-0.422,0.281-0.832,0.38-1.225 c-2.647,0.447-7.325,0.556-12.742-2.386L187.622,297.767z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#A56F62",
      strokeWidth: 9,
      strokeMiterlimit: 10
    },
    d: "M548.807,176.591 c38.52,15.355,67.575,2.826,79.903-32.367"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC804D"
    },
    d: "M630.442,160.562l9.631-14.225c2.507-4.124,1.197-9.499-2.926-12.006h0 c-4.123-2.507-9.499-1.197-12.006,2.926l-9.631,14.225L630.442,160.562z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M554.546,179.808l0.695-1.715c1.948-4.803,0.025-10.117-4.295-11.869l0,0 c-4.32-1.752-2.871,4.784-11.349,5.526l-0.695,1.715c-1.948,4.803-0.025,10.117,4.295,11.869l0,0 C547.517,187.085,552.598,184.612,554.546,179.808z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M548.205,170.751L548.205,170.751c0.684-1.118,0.328-2.592-0.789-3.276l-12.865-6.248 c-1.118-0.684-2.592-0.328-3.276,0.789l0,0c-0.684,1.118-0.329,2.592,0.79,3.276l12.865,6.248 C546.047,172.224,547.521,171.868,548.205,170.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M544.555,174.028L544.555,174.028c0.609-1.16,0.158-2.608-1.002-3.217l-13.247-5.392 c-1.16-0.609-2.608-0.158-3.217,1.002l0,0c-0.609,1.16-0.158,2.608,1.002,3.217l13.247,5.392 C542.497,175.639,543.945,175.188,544.555,174.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M543.241,178.313L543.241,178.313c0.535-1.196-0.005-2.613-1.201-3.148l-13.557-4.555 c-1.196-0.535-2.613,0.005-3.148,1.201l0,0c-0.536,1.196,0.005,2.613,1.201,3.148l13.557,4.555 C541.289,180.049,542.706,179.509,543.241,178.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M546.495,184.128L546.495,184.128c0.482-1.219-0.12-2.61-1.338-3.092l-13.745-3.954 c-1.218-0.482-2.61,0.12-3.093,1.339l0,0c-0.482,1.218,0.12,2.61,1.339,3.092l13.745,3.954 C544.62,185.948,546.012,185.346,546.495,184.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56F62"
    },
    d: "M554.374,169.023l-6.982-10.729c0,0-4.566,3.943-1.796,7.861c2.77,3.918,5.419,7.697,5.419,7.697 L554.374,169.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C5C53"
    },
    d: "M534.001,166.233c0.718,0.449,1.455,0.857,2.197,1.256c0.737,0.408,1.5,0.765,2.248,1.15 c0.757,0.367,1.523,0.716,2.292,1.059c0.776,0.329,1.553,0.655,2.356,0.927c-0.712-0.46-1.451-0.865-2.191-1.269 c-0.747-0.388-1.497-0.771-2.255-1.137c-0.767-0.347-1.52-0.723-2.298-1.046C535.577,166.839,534.799,166.516,534.001,166.233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C5C53"
    },
    d: "M528.291,169.72c0.933,0.479,1.883,0.917,2.837,1.344c0.95,0.437,1.922,0.821,2.881,1.235 c0.967,0.395,1.942,0.771,2.919,1.142c0.983,0.355,1.968,0.708,2.974,1.006c-0.928-0.49-1.879-0.925-2.831-1.357 c-0.958-0.417-1.919-0.828-2.887-1.221c-0.975-0.374-1.939-0.778-2.924-1.128C530.279,170.378,529.293,170.028,528.291,169.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C5C53"
    },
    d: "M527.145,175.163c0.951,0.42,1.916,0.798,2.885,1.165c0.965,0.378,1.949,0.701,2.923,1.053 c0.98,0.334,1.967,0.649,2.955,0.958c0.994,0.294,1.988,0.585,3.002,0.819c-0.947-0.432-1.913-0.806-2.88-1.179 c-0.973-0.357-1.947-0.707-2.927-1.04c-0.987-0.313-1.964-0.656-2.96-0.944C529.151,175.697,528.155,175.409,527.145,175.163z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriod);
export default __webpack_public_path__ + "static/media/period.b38029a4f977fce1a66118b1069c79c7.svg";
export { ForwardRef as ReactComponent };